var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-scrub",style:({
    opacity: _vm.scrolling ? 1 : 0,
    pointerEvents: _vm.scrolling ? 'all' : 'none',
    height: _vm.tabSize + 'px',
    top: _vm.topCss,
})},[_c('div',{staticClass:"scrub-container"},[_c('v-sheet',{staticClass:"scrub-date",attrs:{"rounded":""}},[_vm._v(_vm._s(_vm.formattedDate))]),_c('v-sheet',{staticClass:"scrub-tab",style:({
                width: _vm.tabSize + 'px',
                height: _vm.tabSize + 'px',
             }),attrs:{"elevation":"7"},on:{"touchstart":_vm.touchScrubStart,"mousedown":_vm.scrubStart}},[_c('v-icon',[_vm._v("mdi-unfold-more-horizontal")])],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }